export default __webpack_public_path__ + "static/media/revelo-logo.91cfdb10.png";